import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import SelectSmall from './SelectSmall';
import ClientProvider from './client';
export default createDemo(import.meta.url, SelectSmall, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/selects/demos/small/SelectSmall.tsx",
    "fileName": "SelectSmall.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport InputLabel from '@mui/material/InputLabel';\nimport MenuItem from '@mui/material/MenuItem';\nimport FormControl from '@mui/material/FormControl';\nimport Select from '@mui/material/Select';\nimport type { SelectChangeEvent } from '@mui/material/Select';\n\nexport default function SelectSmall() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [age, setAge] = React.useState('');\n\n  const handleChange = (event: SelectChangeEvent) => {\n    setAge(event.target.value);\n  };\n\n  return (\n    <FormControl sx={{ m: 1, minWidth: 120 }} size=\"small\">\n      <InputLabel id=\"demo-select-small-label\">Age</InputLabel>\n      <Select\n        labelId=\"demo-select-small-label\"\n        id=\"demo-select-small\"\n        value={age}\n        label=\"Age\"\n        onChange={handleChange}\n      >\n        <MenuItem value=\"\">\n          <em>None</em>\n        </MenuItem>\n        <MenuItem value={10}>Ten</MenuItem>\n        <MenuItem value={20}>Twenty</MenuItem>\n        <MenuItem value={30}>Thirty</MenuItem>\n      </Select>\n    </FormControl>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 34,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport InputLabel from '@mui/material/InputLabel';\nimport MenuItem from '@mui/material/MenuItem';\nimport FormControl from '@mui/material/FormControl';\nimport Select from '@mui/material/Select';\nimport type { SelectChangeEvent } from '@mui/material/Select';\n\nexport default function SelectSmall() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [age, setAge] = React.useState('');\n\n  const handleChange = (event: SelectChangeEvent) => {\n    setAge(event.target.value);\n  };\n\n  return (\n    <FormControl sx={{ m: 1, minWidth: 120 }} size=\"small\">\n      <InputLabel id=\"demo-select-small-label\">Age</InputLabel>\n      <Select\n        labelId=\"demo-select-small-label\"\n        id=\"demo-select-small\"\n        value={age}\n        label=\"Age\"\n        onChange={handleChange}\n      >\n        <MenuItem value=\"\">\n          <em>None</em>\n        </MenuItem>\n        <MenuItem value={10}>Ten</MenuItem>\n        <MenuItem value={20}>Twenty</MenuItem>\n        <MenuItem value={30}>Thirty</MenuItem>\n      </Select>\n    </FormControl>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 34,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/InputLabel",
      "@mui/material/MenuItem",
      "@mui/material/FormControl",
      "@mui/material/Select"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
